import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CorporatePayPeriodSettings,
  UpdateCorporatePayPeriodDto
} from './../../models/corporation/corporation-settings.dto';

@Injectable({ providedIn: 'root' })
export class CorporateSettingsService {
  private http = inject(HttpClient);

  private readonly baseUrl = '/api/Corporate';

  getPayPeriodSettings(
    corporateId: string
  ): Observable<Partial<CorporatePayPeriodSettings> | undefined> {
    return this.http.get<Partial<CorporatePayPeriodSettings> | undefined>(
      `${this.baseUrl}/${corporateId}/pay-period-settings`
    );
  }

  updatePayPeriodSettings(
    corporateId: string,
    corporatePayPeriodSetttingsUpdate: UpdateCorporatePayPeriodDto
  ): Observable<CorporatePayPeriodSettings> {
    return this.http.put<CorporatePayPeriodSettings>(
      `${this.baseUrl}/${corporateId}/pay-period-settings`,
      corporatePayPeriodSetttingsUpdate
    );
  }
}
